// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2435782fc4dd0aa990f422234055fc3ba6d3a515/static/css/" + chunkId + "." + {"252":"ddced95f","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};